<link rel="ractive" href="../r-page.html" name="r-page">
<link rel="ractive" href="../components/header.html" name="c-gp-header">
<link rel="ractive" href="../components/google-maps.html" name="c-google-maps">
<link rel="ractive" href="../components/footer.html" name="c-gp-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/filtered-probe-list.html" name="c-filtered-probe-list">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	{{#partial seo}}
		<meta name="canonical" content="/users/{{username}}">
	{{/partial}}

	<c-notification />
	<c-gp-header additionalClasses="header-with-globalping-bg" />

	<div class="p-users">
		<div class="p-users_hero">
			<div class="user-banner">
				<div class="user-banner_user">
					<img width="48" height="48" src="https://github.com/{{username}}.png" class="user-banner_user_avatar">
					<div class="user-banner_user_contact">
						<span class="user-banner_user_contact_username">{{username}}</span>
						<span class="user-banner_user_contact_gh">
							<span>
								<img width="16" height="16" src="{{@shared.assetsHost}}/img/github-outline.svg">
								<a target="_blank" rel="noreferrer" href="https://github.com/{{username}}">{{username}}</a>
							</span>
						</span>
					</div>
				</div>
				{{#if filteredProbes}}
					<div class="user-banner_stats">
						<span>
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/radio.svg">
							{{filteredProbes.length}} {{_.pluralize('probe', filteredProbes.length)}}
						</span>

						{{#each userStats}}
							{{#if count}}
								<span>
									<img width="20" height="20" src="{{@shared.assetsHost}}/img/{{icon}}">
									{{count}} {{~/_.pluralize(...name, count)}}
								</span>
							{{/if}}
						{{/each}}
					</div>
				{{/if}}
			</div>

			<div class="p-users_hero_map-wrapper">
				<c-google-maps
					class="p-users_hero_map-wrapper_map"
					iwClass="p-users_iw"
					probesByCoords="{{probesByCoords}}"
					hasCluster="{{true}}"
					focusOnChange="{{true}}"
				/>
			</div>
		</div>

		<div class="p-users_filtered-list">
			<c-filtered-probe-list
				rawProbes="{{userProbes}}"
				filteredProbes="{{filteredProbes}}"
				location="{{location}}"
				locationCompletedValue="{{locationCompletedValue}}"
				groupBy="{{groupBy}}"
				sortOrder="{{sortOrder}}"
				refresh="{{@this.getProbesData}}"
				probesLoading="{{probesLoading}}"
				probesError="{{probesError}}"
				defaultSortOptions="{{defaultSortOptions}}"
				filter="{{filter}}"
			/>
		</div>
	</div>

	<c-gp-footer />
</r-page>

<script>
	const _ = require('../../assets/js/_');
	const listeners = require('../../assets/js/utils/listeners');
	const http = require('../../assets/js/utils/http');
	const dataCache = require('../../assets/js/utils/data-cache');

	const GROUP_DEFAULT = 'disabled';

	const DEFAULT_SORT_OPTIONS = {
		'country': 'alphabetically',
		'city': 'alphabetically',
		'network': 'probe-count',
		'country-network': 'alphabetically',
		'city-network': 'alphabetically',
		'disabled': 'alphabetically',
	};

	component.exports = {
		data () {
			return {
				_,
				username: '',
				probesLoading: true,
				probesError: null,
				userProbes: null,
				probesByCoords: null,
				filteredProbes: null,
				location: 'World',
				locationCompletedValue: '',
				groupBy: GROUP_DEFAULT,
				sortOrder: DEFAULT_SORT_OPTIONS[GROUP_DEFAULT],
				defaultSortOptions: DEFAULT_SORT_OPTIONS,
				userStats: {
					asn: {
						name: [ 'ASN' ],
						icon: 'file-text.svg',
						count: 0,
					},
					city: {
						name: [ 'city', 'cities' ],
						icon: 'city.svg',
						count: 0,
					},
					country: {
						name: [ 'country', 'countries' ],
						icon: 'country.svg',
						count: 0,
					},
				},
			};
		},
		computed: {
			title () {
				return `${this.get('username')}'s Probes - Globalping`;
			},
			description () {
				return `Find ${this.get('username')}'s Globalping probes.`;
			},
			filter: {
				get () {
					let location = this.get('locationCompletedValue') || '';

					if (location.toLowerCase() === 'world') {
						return '';
					}

					return location.replace(/\+/g, '%');
				},
				set (location) {
					this.set('location', location.replace(/%/g, '+'));
					this.set('locationCompletedValue', location.replace(/%/g, '+'));
				},
			},
			group: {
				get () {
					return this.get('groupBy') === GROUP_DEFAULT ? '' : this.get('groupBy');
				},
				set (group) {
					if (Object.hasOwn(DEFAULT_SORT_OPTIONS, group)) {
						this.set('sortOrder', DEFAULT_SORT_OPTIONS[group]);
					}

					this.set('groupBy', group);
				},
			},
			sort: {
				get () {
					return this.get('sortOrder') === DEFAULT_SORT_OPTIONS[this.get('groupBy')] || this.get('groupBy') === 'disabled' ? '' : this.get('sortOrder');
				},
				set (sort) {
					this.set('sortOrder', sort);
				},
			},
		},
		oninit () {
			if (!Ractive.isServer) {
				this.getProbesData();

				this.observe('filteredProbes', (probes) => {
					if (probes === null) {
						return;
					}

					let entries = Object.entries(this.get('userStats')).map(([ key, value ]) => {
						if (key === 'probe') {
							return [ key, { ...value, count: probes.length }];
						}

						return [ key, { ...value, count: [ ...new Set(probes.map(probe => probe.location[key])) ].length }];
					}).sort((a, b) => b[1].count - a[1].count);

					this.set('userStats', {}); // force reordering
					this.set('userStats', Object.fromEntries(entries));

					let groupedByCoords = this.groupProbes(probes);
					setTimeout(() => this.set('probesByCoords', groupedByCoords), 50);
				});
			}
		},
		onrender () {
			if (!Ractive.isServer) {
				listeners.screenWidthListener(this);
			}
		},
		handleProbesResponse (response) {
			let user = `u-${this.get('username')}`.toLowerCase();
			let userProbes = response
				.filter(probe => probe.tags.some(tag => tag.toLowerCase() === user))
				.sort((a, b) => {
					let aLocation = `${a.location.country}${a.location.city}`;
					let bLocation = `${b.location.country}${b.location.city}`;
					return aLocation < bLocation ? -1 : aLocation > bLocation ? 1 : 0;
				});

			this.set('userProbes', userProbes);
		},
		getProbesData () {
			this.set('probesLoading', true);
			this.set('probesError', null);

			dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes)
				.then(value => this.handleProbesResponse(value))
				.catch(error => this.set('probesError', error))
				.finally(() => this.set('probesLoading', false));
		},
		groupProbes (probes) {
			// group probes by Coordinates
			return probes.reduce((groupedByCoords, probe) => {
				let coords = `${probe.location.latitude}, ${probe.location.longitude}`;

				if (!Object.hasOwn(groupedByCoords, coords)) {
					groupedByCoords[coords] = [];
				}

				groupedByCoords[coords].push(probe);

				return groupedByCoords;
			}, {});
		},
	};
</script>
